import { EntityId } from '@reduxjs/toolkit';
import { coreDialogApi } from '../api';

export const useCanSendMessage = (dialogId: EntityId) => {
  return coreDialogApi.endpoints.canSendMessage.useQuery({ dialogId });
};
